export default __webpack_public_path__ + "edd07401985313f391d83cc26c85d0da.png";